import ExpensePage from "@/app/(app)/(crew)/home/[shift]/expense";

export default ExpensePage;
